import { RouteLocation, RouteRecordRaw, createRouter, createWebHistory } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    redirect: {
      name: "index",
    },
    meta: { pageName: "首页", keepAlive: true },
  },
  {
    path: "/index",
    name: "index",
    component: () => import("./pages/index/index.vue"),
    props: true,
    meta: {
      title: "小布咕商城",
      pageName: "首页",
      showTabBar: false,
      keepAlive: true,
    },
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("./pages/detail/detail.vue"),
    meta: {
      title: "",
      pageName: "商品详情页",
      customNavBarTitle: true,
    },
  },
  {
    path: "/list",
    name: "list",
    component: () => import("./pages/list/list.vue"),
    meta: {
      title: "",
      pageName: "更多商品页",
      keepAlive: true,
    },
  },
  {
    path: "/address",
    name: "address",
    component: () => import("./pages/address/address.vue"),
    meta: {
      requireAuth: true, //需要登录才能访问
      title: "新增收货地址",
      pageName: "收货地址编辑页",
    },
  },
  {
    path: "/addressList",
    name: "addressList",
    component: () => import("./pages/addressList/addressList.vue"),
    meta: {
      requireAuth: true,
      title: "收货地址",
      pageName: "收货地址页",
    },
  },
  {
    path: "/modifyAddress",
    name: "modifyAddress",
    component: () => import("./pages/modifyAddress/modifyAddress.vue"),
    meta: {
      requireAuth: true,
      title: "修改地址",
      pageName: "修改地址页",
    },
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("./pages/myOrder/orderList.vue"),
    props: true,
    meta: {
      requireAuth: true,
      title: "我的订单",
      pageName: "我的订单页",
      keepAlive: true,
    },
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("./pages/myOrder/orderDetail.vue"),
    props: true,
    meta: {
      requireAuth: true,
      title: "订单详情",
      pageName: "订单详情页",
    },
  },
  {
    path: "/logistics",
    name: "logistics",
    component: () => import("./pages/myOrder/logistics.vue"),
    props: true,
    meta: {
      requireAuth: true,
      title: "物流查询",
      pageName: "物流查询页",
    },
  },
  {
    path: "/orderConfirm",
    name: "orderConfirm",
    component: () => import("./pages/orderConfirm/orderConfirm.vue"),
    meta: {
      requireAuth: true,
      title: "确认订单",
      pageName: "确认订单页",
    },
  },
  {
    path: "/buyResult",
    name: "buyResult",
    component: () => import("./pages/buyResult/buyResult.vue"),
    meta: {
      requireAuth: true,
      title: "支付结果",
      pageName: "购买完成页",
      customNavBarTitle: true,
    },
  },
  {
    path: "/my",
    name: "my",
    component: () => import("./pages/my/myIndex.vue"),
    meta: {
      requireAuth: true,
      title: "我的",
      pageName: "我的页",
      showTabBar: true,
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("./pages/cart/cart.vue"),
    meta: {
      requireAuth: true,
      title: "购物车",
      pageName: "购物车页",
      desc: "购物车",
      showTabBar: true,
    },
  },
  {
    path: "/couponList",
    name: "couponList",
    component: () => import("./pages/couponList/couponList.vue"),
    meta: {
      requireAuth: true,
      title: "我的优惠券",
      pageName: "我的优惠券页",
    },
  },
  {
    path: "/couponDetail",
    name: "couponDetail",
    component: () => import("./pages/couponDetail/couponDetail.vue"),
    meta: {
      title: "使用优惠券",
      pageName: "使用优惠券页",
      keepAlive: true,
    },
  },
  {
    path: "/themeList",
    name: "themeList",
    redirect: (to) => {
      if (to.query.pageid) {
        return {
          name: "themeListWithId",
          params: { pageid: to.query.pageid },
          query: {}, // 清空查询参数
        };
      } else {
        return {
          name: "index",
        };
      }
    },
  },
  {
    path: "/themeList/:pageid",
    name: "themeListWithId",
    component: () => import("./pages/themeList/themeList.vue"),
    props: true,
    meta: {
      title: "小布咕商城",
      pageName: "专题页",
      keepAlive: true,
      customNavBarTitle: true,
    },
  },
  {
    path: "/licence/:type",
    name: "licence",
    component: () => import("./pages/my/licence/licence.vue"),
    meta: {},
  },
  {
    path: "/bonus",
    name: "bonus",
    component: () => import("./pages/bonus/index.vue"),
    meta: {
      requireAuth: true,
      title: "奖励金当钱花",
      pageName: "签到页",
    },
  },
  {
    path: "/bonus/list",
    name: "bonusList",
    component: () => import("./pages/bonus/list.vue"),
    meta: {
      requireAuth: true,
      title: "奖励金记录",
      pageName: "奖励金记录页",
    },
  },
  {
    path: "/helpCenter/detail/:id",
    name: "helpCenterDetail",
    component: () => import("./pages/helpCenter/detail.vue"),
    meta: {
      title: "",
      desc: "",
    },
  },
  {
    path: "/gift",
    name: "giftList",
    component: () => import("./pages/gift/index.vue"),
    meta: {
      requireAuth: true,
      title: "发券中心",
      pageName: "发券中心页",
    },
  },
  {
    path: "/gift/create",
    name: "giftCreate",
    component: () => import("./pages/gift/create.vue"),
    meta: {
      requireAuth: true,
      title: "创建券包",
      pageName: "创建券包页",
    },
  },
  {
    path: "/gift/detail",
    name: "giftDetail",
    component: () => import("./pages/gift/detail.vue"),
    meta: {
      requireAuth: true,
      title: "券包详情",
      pageName: "券包详情页",
    },
  },
  {
    path: "/gift/receive",
    name: "giftReceive",
    component: () => import("./pages/gift/receive.vue"),
    meta: {
      requireAuth: true,
      title: "小布咕",
      pageName: "券包领取页",
      desc: "商城礼包",
    },
  },
  {
    path: "/gift/record",
    name: "giftRecord",
    component: () => import("./pages/gift/record.vue"),
    meta: {
      requireAuth: true,
      title: "领取记录",
      pageName: "领取记录页",
    },
  },
  {
    path: "/couponCodeRedemption",
    name: "couponCodeRedemption",
    component: () => import("./pages/couponCodeRedemption/couponCodeRedemption.vue"),
    meta: {
      requireAuth: true,
      title: "优惠券兑换",
      pageName: "优惠券兑换",
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("./pages/search/search.vue"),
    meta: {
      title: "搜索",
      pageName: "搜索详情页",
      keepAlive: true,
    },
  },
  {
    path: "/promotion/:id",
    name: "promotion",
    component: () => import("./pages/promotion/promotion.vue"),
    meta: {
      pageName: "促销活动详情页",
      keepAlive: true,
    },
  },
  {
    path: "/refund/detail",
    name: "refundDetail",
    component: () => import("./pages/refund/detail.vue"),
    meta: {
      requireAuth: true,
      title: "退款详情",
      pageName: "退款详情页",
    },
  },
  {
    path: "/refund/express",
    name: "refundExpress",
    component: () => import("./pages/refund/express.vue"),
    meta: {
      requireAuth: true,
      title: "填写单号",
      pageName: "填写单号页",
    },
  },
  {
    path: "/refund/history",
    name: "refundHistory",
    component: () => import("./pages/refund/history.vue"),
    meta: {
      requireAuth: true,
      title: "协商记录",
      pageName: "协商记录页",
    },
  },
  {
    path: "/refund/create",
    name: "refundCreate",
    component: () => import("./pages/refund/create.vue"),
    meta: {
      requireAuth: true,
      title: "申请退款",
      pageName: "退款申请页",
    },
  },
  {
    path: "/refund/start",
    name: "refundStart",
    component: () => import("./pages/refund/start.vue"),
    meta: {
      requireAuth: true,
      title: "选择退款商品",
      pageName: "选择退款商品页",
    },
  },
  {
    path: "/snapshotList",
    name: "snapshotList",
    component: () => import("./pages/myOrder/snapshotList.vue"),
    props: true,
    meta: {
      requireAuth: true,
      title: "交易快照",
      pageName: "交易快照列表页",
    },
  },
  {
    path: "/snapshotDetail",
    name: "snapshotDetail",
    component: () => import("./pages/myOrder/snapshotDetail.vue"),
    props: true,
    meta: {
      requireAuth: true,
      title: "交易快照",
      pageName: "交易快照详情页",
    },
  },
  {
    path: "/lottery",
    name: "lottery",
    component: () => import("./pages/lottery/lottery.vue"),
    meta: {
      pageName: "活动抽奖页",
      keepAlive: true,
    },
  },
  {
    path: "/categoryList",
    name: "categoryList",
    component: () => import("./pages/categoryList/categoryList.vue"),
    meta: {
      pageName: "分类页",
      title: "分类",
      keepAlive: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("./pages/notFound/notFound.vue"),
    meta: {},
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: (to) => {
      return {
        name: "index",
        query: {}, // 清空查询参数
      };
    },
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // savedPosition 会自动保存用户离开页面时的滚动位置
    // console.debug("scroll behavior", to, from, savedPosition);
    if (savedPosition) {
      return savedPosition; // 恢复之前的位置
    }
    return { top: 0 }; // 默认回到顶部
  },
});

/**
 * router push跳转加传t=时间戳
 * */
const originalPush: typeof router.push = router.push;
router.push = function (location: RouteLocation) {
  const timestamp = Date.now();
  const newQuery = {
    ...("query" in location ? location.query : {}),
    t: timestamp,
  };
  return originalPush.call(this, {
    ...location,
    query: newQuery,
  });
};
export default router;
